import React from "react";
import Navbar from "../components/Navbar";
import MarqueeTicker from "../components/MarqueeTicker";
import Hero from "../components/Hero";
import WhyProducers from "../components/WhyProducers";
import WhereHeard from "../components/WhereHeard";
import WhereSeen from "../components/WhereSeen";
import ApplicationForm from "../components/ApplicationForm";
import Footer from "../components/Footer";

export default function HomePage() {
  return (
    <main className="min-h-screen bg-[#050608] text-white relative">
      {/* Global subtle grid overlay */}
      <div className="global-grid fixed inset-0 pointer-events-none z-0" aria-hidden />

      <div className="relative z-10">
        <MarqueeTicker />
        <Navbar />
        <Hero />
        <div id="why">
          <WhyProducers />
        </div>
        <div id="seen">
          <WhereHeard />
        </div>
        <WhereSeen />
        <ApplicationForm />
        <Footer />
      </div>
    </main>
  );
}
